export enum PyramidPaths {
  CowBacteria = 'kobundna-juverbakterier',
  Emergency = 'akutatgarder',
  EnvironmentBacteria = 'miljobakterier',
  RobotCowBacteria = 'robotmjolkning-kobunda-bakterier',
  RobotEnvironmentBacteria = 'robotmjolkning-miljobakterier',
  SummerPeak = 'sommartop',
}
